import { action, computed, makeObservable } from 'mobx';
import { IMealItemMdfExclModal } from '../types/MealItemMdfExclModal';
import { modalStore } from '~/mobx/modalStore';
import { IMealItem } from '~/types/combo';
import { IProductV4Exclusion, IProductV4Modifier, IProductV4ModifierOption } from '~/types/product';

class MealItemMdfExclModalStore {
  constructor() {
    makeObservable(this);
  }

  private item: IMealItem | null = null;

  @computed public get modifiers(): IProductV4Modifier[] {
    if (!this.item || !this.item.modifiers?.length) return [];

    return this.item.modifiers.reduce((sum: IProductV4Modifier[], current) => {
      const options: IProductV4ModifierOption[] = current.options.filter((option) => this.checkModifierOptionAvailable(option));

      if (options.length) return sum.concat(current);

      return sum;
    }, []);
  }
  private checkModifierOptionAvailable = (option: IProductV4ModifierOption): boolean => {
    return Boolean(option.status && !option.is_delete);
  };

  @computed public get exclusions(): IProductV4Exclusion[] {
    // TODO: combo exclusions
    return [];
    // if (!this.item || !this.item.exclusions?.length) return [];

    // return this.item.exclusions;
  }

  public initStore = (props: IMealItemMdfExclModal) => {
    this.item = props.item;
  };

  @action public onCloseModal = () => {
    modalStore.closeMealItemMdfExclModal();
  };
}

export const mealItemMdfExclModalStore = new MealItemMdfExclModalStore();
